import { render } from "./CreateReminder.vue?vue&type=template&id=de35bb7a"
import script from "./CreateReminder.vue?vue&type=script&lang=js"
export * from "./CreateReminder.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__